/**
 * Bank brand color lookup — fallback when Plaid primary_color not available.
 * Add entries as users connect new institutions.
 */

export const BANK_BRAND_COLORS: Record<string, string> = {
  'Chase': '#117ACA',
  'Bank of America': '#012169',
  'Wells Fargo': '#D71E28',
  'Citi': '#003B70',
  'Capital One': '#D03027',
  'USAA': '#1B3A5C',
  'TD Bank': '#2D8C2E',
  'PNC': '#F58220',
  'US Bank': '#D12830',
  'Ally': '#6F2B91',
};

/** Resolve brand color: prefer Plaid data, fallback to lookup, then default */
export function getBankColor(institutionName: string, plaidColor?: string | null): string {
  if (plaidColor) return plaidColor;
  return BANK_BRAND_COLORS[institutionName] || '#666';
}
